import { Component } from '@angular/core';
import { IPrinterItem } from 'src/app/private/terminal/repositories/printers.repository';
import { IPrintObject } from '../printer.service';
import { AlertController, ModalController } from '@ionic/angular';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  templateUrl: './printer-preview.component.html',
})
export class PrinterPreviewComponent {
  printer: IPrinterItem;
  printText: string;
  printers: IPrinterItem[] = [];
  printObjects: IPrintObject[] = [];
  printTestAction: (printer: IPrinterItem) => {};
  printAction: (printer: IPrintObject) => {};

  constructor(
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private shared: SharedService
  ) {}

  print() {
    if (!this.printer) {
      this.alertCtrl
        .create({
          message: $localize`:@@printersPage.pickPrinterMessage:Оберіть принтер`,
          buttons: [$localize`:@@inventory.close:Закрити`],
        })
        .then((alert) => alert.present());
      return;
    }

    this.printAction({
      printer: this.printer,
      printText: this.printText,
    });
  }

  async selectPrinter() {
    const selectItems = this.printObjects.map((po) => {
      return {
        label: `${po.printer.name} ${po.printer.ip}`,
        value: po,
      };
    });
    const res = await this.shared.selectModal(
      selectItems,
      $localize`:@@printersPage.pickPrinterMessage:Оберіть принтер`
    );
    if (!res) {
      return;
    }

    this.printText = res.printText;
    this.printer = res.printer;
  }

  testPrint() {
    if (!this.printer) {
      this.alertCtrl
        .create({
          message: $localize`:@@printersPage.pickPrinterMessage:Оберіть принтер`,
          buttons: [$localize`:@@inventory.close:Закрити`],
        })
        .then((alert) => alert.present());
      return;
    }

    this.printTestAction(this.printer);
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
